module.exports = __webpack_public_path__ + "img/andrew-600x600.fc281984.png";